(function () {
  const modal = document.getElementById('ap-gift-campaign');


  if (!modal) {
    console.warn('[Anna Prata Gift] Modal #ap-gift-campaign não encontrado nesta página.');
    return;
  }


  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }


  const threshold = Number(modal.dataset.threshold || 100000);
  const giftVariantId = Number(modal.dataset.giftVariantId);
  const storageKey = modal.dataset.storageKey || 'ap-gift-campaign';


  const redeemButton = modal.querySelector('[data-ap-gift-redeem]');
  const closeButtons = modal.querySelectorAll('[data-ap-gift-close]');
  const rootUrl = window.Shopify?.routes?.root || '/';


  let isEvaluating = false;
  let isRemovingGift = false;
  let watcherId = null;


  if (!giftVariantId) {
    console.warn('[Anna Prata Gift] Variant ID do presente não configurado.');
    return;
  }


  function cartUrl(path) {
    const cleanRoot = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    return `${cleanRoot}${path}`;
  }


  function isCartRequest(url) {
    if (!url) return false;
    const stringUrl = String(url);
    return (
      stringUrl.includes('/cart/add') ||
      stringUrl.includes('/cart/change') ||
      stringUrl.includes('/cart/update') ||
      stringUrl.includes('/cart/clear')
    );
  }


  async function getCart() {
    const response = await fetch(cartUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });


    if (!response.ok) {
      throw new Error('[Anna Prata Gift] Não foi possível buscar o carrinho.');
    }


    return response.json();
  }


  function getGiftLineItem(cart) {
    return cart.items.find(function (item) {
      return Number(item.variant_id) === giftVariantId;
    });
  }


  function giftAlreadyInCart(cart) {
    return Boolean(getGiftLineItem(cart));
  }


  function forceModalStyles() {
    Object.assign(modal.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '2147483647',
      display: 'grid',
      placeItems: 'center',
      opacity: '1',
      visibility: 'visible',
      pointerEvents: 'auto'
    });


    const overlay = modal.querySelector('.ap-gift-campaign__overlay');
    const card = modal.querySelector('.ap-gift-campaign__card');


    if (overlay) {
      Object.assign(overlay.style, {
        position: 'absolute',
        inset: '0',
        zIndex: '1'
      });
    }


    if (card) {
      Object.assign(card.style, {
        position: 'relative',
        zIndex: '2',
        display: 'block',
        opacity: '1',
        visibility: 'visible'
      });
    }
  }


  function startWatcher() {
    if (watcherId) return;
    watcherId = setInterval(function () {
      evaluateCart('watcher');
    }, 2500);
  }


  function openModal() {
    if (sessionStorage.getItem(`${storageKey}:shown`) === 'true') {
      return;
    }


    modal.hidden = false;


    requestAnimationFrame(function () {
      modal.classList.add('is-visible');
      forceModalStyles();
    });


    sessionStorage.setItem(`${storageKey}:shown`, 'true');
    console.info('[Anna Prata Gift] Modal exibido.');
  }


  function closeModal() {
    modal.classList.remove('is-visible');


    Object.assign(modal.style, {
      opacity: '0',
      visibility: 'hidden',
      pointerEvents: 'none'
    });


    window.setTimeout(function () {
      modal.hidden = true;
    }, 260);
  }


  async function removeGiftFromCart(giftItem, source) {
    if (!giftItem || isRemovingGift) return;


    isRemovingGift = true;


    try {
      console.info('[Anna Prata Gift] Removendo presente automaticamente:', {
        origem: source || 'auto',
        title: giftItem.title,
        variant_id: giftItem.variant_id,
        key: giftItem.key
      });


      const response = await fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: giftItem.key || giftItem.variant_id,
          quantity: 0
        })
      });


      if (!response.ok) {
        const errorText = await response.text();
        console.warn('[Anna Prata Gift] Shopify recusou a remoção do presente:', {
          status: response.status,
          resposta: errorText
        });
        throw new Error(errorText || 'Não foi possível remover o presente.');
      }


      sessionStorage.removeItem(`${storageKey}:shown`);


      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('ap:gift-removed'));


      console.info('[Anna Prata Gift] Presente removido porque o carrinho saiu da condição.');
    } catch (error) {
      console.warn('[Anna Prata Gift] Erro ao remover presente:', error);
    } finally {
      isRemovingGift = false;
    }
  }


  async function evaluateCart(source) {
    if (isEvaluating) return;


    isEvaluating = true;


    try {
      const cart = await getCart();


      const cartTotal = Number(cart.total_price);
      const reachedThreshold = cartTotal >= threshold;
      const giftItem = getGiftLineItem(cart);
      const hasGift = Boolean(giftItem);
      const alreadyShown = sessionStorage.getItem(`${storageKey}:shown`) === 'true';


      console.info('[Anna Prata Gift] Avaliação do carrinho:', {
        origem: source || 'manual',
        totalCentavos: cartTotal,
        minimoCentavos: threshold,
        atingiuMinimo: reachedThreshold,
        presenteNoCarrinho: hasGift,
        modalJaExibido: alreadyShown,
        giftVariantId: giftVariantId
      });


      if (hasGift && !reachedThreshold) {
        await removeGiftFromCart(giftItem, source);
        return;
      }


      if (reachedThreshold && !hasGift && !alreadyShown) {
        openModal();
      }
    } catch (error) {
      console.warn('[Anna Prata Gift] Erro ao avaliar carrinho:', error);
    } finally {
      isEvaluating = false;
    }
  }


  function scheduleEvaluateCart(source) {
    window.setTimeout(function () { evaluateCart(source); }, 400);
    window.setTimeout(function () { evaluateCart(`${source}:delay`); }, 1300);
    window.setTimeout(function () { evaluateCart(`${source}:final`); }, 2500);
  }


  async function redeemGift() {
    if (!redeemButton) {
      console.warn('[Anna Prata Gift] Botão de resgate não encontrado.');
      return;
    }


    redeemButton.disabled = true;
    redeemButton.textContent = 'RESGATANDO...';


    try {
      const cart = await getCart();


      if (Number(cart.total_price) < threshold) {
        redeemButton.textContent = 'VALOR MÍNIMO NÃO ATINGIDO';
        window.setTimeout(function () {
          redeemButton.disabled = false;
          redeemButton.textContent = 'RESGATAR PRESENTE';
        }, 1800);
        return;
      }


      if (!giftAlreadyInCart(cart)) {
        const response = await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: giftVariantId,
            quantity: 1,
            properties: { _campanha: 'Primavera - Presente 1000+' }
          })
        });


        if (!response.ok) {
          const errorText = await response.text();
          console.warn('[Anna Prata Gift] Shopify recusou o presente:', {
            status: response.status,
            resposta: errorText
          });
          throw new Error(errorText || 'Não foi possível adicionar o presente.');
        }
      }


      const updatedCart = await getCart();


      if (!giftAlreadyInCart(updatedCart)) {
        throw new Error('O presente foi solicitado, mas não apareceu no carrinho após a atualização.');
      }


      redeemButton.textContent = 'PRESENTE ADICIONADO';


      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('ap:gift-added'));


      modal.classList.remove('is-visible');
      Object.assign(modal.style, {
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none'
      });


      window.setTimeout(function () {
        modal.hidden = true;
        const cartToggle = document.querySelector('[aria-controls="cart-drawer"]');
        if (cartToggle) cartToggle.click();
      }, 320);


    } catch (error) {
      console.warn('[Anna Prata Gift] Erro ao resgatar presente:', error);
      redeemButton.disabled = false;
      redeemButton.textContent = 'TENTAR NOVAMENTE';
    }
  }


  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });


  if (redeemButton) {
    redeemButton.addEventListener('click', redeemGift);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      evaluateCart('DOMContentLoaded');
      startWatcher();
    });
  } else {
    evaluateCart('init-ready');
    startWatcher();
  }


  document.addEventListener('cart:updated', function () { scheduleEvaluateCart('cart:updated'); });
  document.addEventListener('cart:refresh', function () { scheduleEvaluateCart('cart:refresh'); });
  document.addEventListener('cart:change', function () { scheduleEvaluateCart('cart:change'); });


  document.addEventListener('click', function (event) {
    const clickedCartAction =
      event.target.closest('button[name="add"]') ||
      event.target.closest('[data-cart-add]') ||
      event.target.closest('form[action*="/cart/add"]') ||
      event.target.closest('cart-drawer button') ||
      event.target.closest('line-item-quantity button') ||
      event.target.closest('quantity-selector button');


    if (clickedCartAction) {
      scheduleEvaluateCart('click-cart-action');
      startWatcher();
    }
  }, true);


  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      scheduleEvaluateCart('submit-cart-add');
      startWatcher();
    }
  }, true);


  const originalFetch = window.fetch;
  window.fetch = async function () {
    const requestUrl = arguments[0]?.url || arguments[0];
    const response = await originalFetch.apply(this, arguments);
    if (isCartRequest(requestUrl)) {
      scheduleEvaluateCart('fetch-cart-request');
      startWatcher();
    }
    return response;
  };


  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open = function (method, url) {
    this._apGiftUrl = url;
    return originalXHROpen.apply(this, arguments);
  };


  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('loadend', function () {
      if (isCartRequest(this._apGiftUrl)) {
        scheduleEvaluateCart('xhr-cart-request');
        startWatcher();
      }
    });
    return originalXHRSend.apply(this, arguments);
  };


  window.AP_GIFT_CAMPAIGN = {
    evaluateCart: function () { return evaluateCart('console'); },
    openModal: function () {
      sessionStorage.removeItem(`${storageKey}:shown`);
      openModal();
    },
    closeModal: closeModal,
    clearSession: function () {
      sessionStorage.removeItem(`${storageKey}:shown`);
      startWatcher();
      console.info('[Anna Prata Gift] Sessão limpa.');
    },
    status: async function () {
      const cart = await getCart();
      console.info('[Anna Prata Gift] Status:', {
        totalCentavos: cart.total_price,
        minimoCentavos: threshold,
        presenteNoCarrinho: giftAlreadyInCart(cart),
        modalJaExibido: sessionStorage.getItem(`${storageKey}:shown`) === 'true',
        giftVariantId: giftVariantId,
        itens: cart.items.map(function (item) {
          return {
            title: item.title,
            variant_id: item.variant_id,
            quantity: item.quantity,
            key: item.key
          };
        })
      });
    },
    testAddGift: function () { return redeemGift(); }
  };


  evaluateCart('init');
  startWatcher();
})();



